
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Görselleştirmeler',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Bir sayı girin',
	'maxValuePlaceholder': 'Bir sayı girin',
	'customRangeErrorMessage': 'Değer bir sayı olmalıdır',
	'propFillColor': 'Dolgu rengi',
	'propBorderColor': 'Kenarlık rengi',
	'propColorPalette': 'Geçerli renk paleti',
	'propColorPaletteChangeLabel': 'Renk paletini değiştir',
	'propNewColorPaletteLabel': 'Özel renk paleti oluştur',
	'propNewHeatPaletteLabel': 'Özel ısı paleti oluştur',
	'propDonutRadius': 'Halka yarıçapı',
	'showTitleLabel': 'Başlığı göster',
	'titleTypeLabel': 'Başlık tipi',
	'smartTitleLabel': 'Akıllı başlık',
	'customTitleLabel': 'Özel başlık',
	'noTitleLabel': 'Başlık yok',
	'propHeatScalePalette': 'Geçerli ısı paleti',
	'propHeatPaletteChangeLabel': 'Isı paletini değiştir',
	'propMaintainAxisScales': 'Eksen ölçeğini koru',
	'propLineAndSymbolColor': 'Çizgi ve simge rengi',
	'propLineAndSymbolPalette': 'Çizgi ve simge renk paleti',
	'propElementColor': 'Öğe rengi',
	'propColumnColor': 'Sütun rengi',
	'propColumnPalette': 'Sütun renk paleti',
	'propColumnHeatPalette': 'Sütun ısı paleti',
	'propBarColor': 'Çubuk rengi',
	'propGoalColor': 'Hedef renk',
	'propToColor': 'Bitiş rengi',
	'propFromColor': 'Başlangıç rengi',
	'propNumberValidationErrorMessageId': 'Bir sayı girin',
	'fontSizeAuto': 'Otomatik',
	'propAutoBinCount': 'Grup sayısı',
	'propAutoBinToggle': 'Otomatik gruplama',
	'tabName_general': 'Genel',
	'tabName_visDetails': 'Ayrıntılar',
	'tabName_animation': 'Animasyon',
	'tabName_mediaDetails': 'Ortam ayrıntıları',
	'tabName_webDetails': 'Web sayfası ayrıntıları',
	'tabName_imageDetails': 'Resim ayrıntıları',
	'tabName_visualization': 'Görselleştirme',
	'tabName_text': 'Metin',
	'sectionName_colorsAndThemes': 'Renk ve temalar',
	'sectionName_appearance': 'Görünüş',
	'sectionName_general': 'Genel',
	'sectionName_colorPalette': 'Renk',
	'sectionName_axis': 'Eksen',
	'sectionName_axis_label': 'Eksen',
	'sectionName_legend': 'Açıklama',
	'sectionName_chart': 'Grafik',
	'sectionName_regionLayer': 'Bölgeler katmanı',
	'sectionName_pointLayer': 'Noktalar katmanı',
	'sectionName_latLongLayer': 'Enlem/boylam katmanı',
	'sectionName_pathLayer': 'Yol katmanı',
	'sectionName_xAxis': 'X ekseni',
	'sectionName_yAxis': 'Y ekseni',
	'sectionName_xAxis_title': 'X ekseni başlığı',
	'sectionName_yAxis_title': 'Y ekseni başlığı',
	'sectionName_xAxis_label': 'X ekseni etiketi',
	'sectionName_yAxis_label': 'Y ekseni etiketi',
	'sectionName_column_yAxis': 'Sütun Y ekseni',
	'sectionName_column_yAxis_label': 'Sütun Y ekseni etiketi',
	'sectionName_column_yAxis_title': 'Sütun Y ekseni başlığı',
	'sectionName_line_yAxis': 'Satır Y ekseni',
	'sectionName_line_yAxis_label': 'Satır Y ekseni etiketi',
	'sectionName_line_yAxis_title': 'Satır Y ekseni başlığı',
	'sectionName_title': 'Başlık',
	'sectionName_dataValueLabels': 'Veri değeri etiketleri',
	'sectionName_style': 'Stil',
	'propTransparencyDescription': 'Nesneyi daha fazla veya daha az şeffaf yapın. 0 ila 100 arasında bir değer girin',
	'smart_annotation_unauthorized': 'Ek açıklamalar: yetkisiz erişim',
	'smart_annotation_method': 'Ek açıklamalar: yönteme izin verilmiyor',
	'smart_annotation_media': 'Ek açıklamalar: ortam tipine izin verilmiyor',
	'smart_annotation_input': 'Ek açıklamalar: giriş geçersiz',
	'smart_annotation_internal': 'Ek açıklamalar: iç sistem hatası',
	'smart_annotation_generic_error': 'Ek açıklamalar: hizmet hatası',
	'smart_annotation_dialog_title': 'Öngörüler',
	'smart_annotation_Show_Insights': 'Öngörüleri göster',
	'smart_annotation_Relationship': 'İlişki:',
	'forecast_enter_number': 'Şu değerler arasında bir sayı girin: ',
	'and': ' ve ',
	'smart_errors': 'Ek açıklama hataları:',
	'smart_warnings': 'Ek açıklama uyarıları:',
	'smart_annotation_insight_icon_title': 'Öngörüler',
	'smart_annotations_toggle_on': 'Öngörüleri aç',
	'smart_annotations_toggle_off': 'Öngörüleri kapat',
	'smart_annotation_toggle_on': 'Aç',
	'smart_annotation_toggle_off': 'Kapat',
	'smart_annotation_insight_unavailable': 'Öngörüler şu anda kullanılamıyor',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Üst değer: veya Alt değer: % süzgeci uygulandığında öngörüler kullanılamaz',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Üst değer: veya Alt değer: % süzgeci uygulandığında tahmin kullanılamaz',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Bir üst veya alt süzgeç uygulandığında ve alanda birden fazla sütun olduğunda öngörüler kullanılabilir değildir',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Bir üst veya alt süzgeç uygulandığında ve alanda birden fazla sütun olduğunda tahmin kullanılamaz.',
	'forecast_title': 'Tahmin',
	'forecast_show': 'Tahmini göster',
	'forecast_toggle_on': 'Öngörüleri aç',
	'forecast_toggle_off': 'Öngörüleri kapat',
	'statDetailsPerspectiveTitle': 'Çözümleme',
	'emptyStatDetailsPanel': 'Geçerli görselleştirme için ek bir analiz yok.',
	'predict_errors': 'Analiz hataları',
	'predict_warnings': 'Analiz uyarıları',
	'fpd_invalid_data_source': 'Bu veri kaynağının ilişkili bir akıllı modülü yok',
	'fpd_network_issue': 'Bu veri kaynağına karşı analiz gerçekleştirilirken bir sorun oluştu',
	'fpd_data_source_category': 'Akıllı modül eksik',
	'fpd_response_errors': 'Önerilen sürücü hataları',
	'fpd_response_warnings': 'Önerilen sürücü uyarıları',
	'catalyst_service_bad_request': 'Hatalı istek',
	'catalyst_service_unkown_Id': 'Bilinmeyen istek tanıtıcısı bulundu',
	'catalyst_service_internal_server_error': 'İç Sunucu Hatası',
	'catalyst_service_generic_error': 'Katalizör hizmeti hatası',
	'catalyst_service_error': 'Bu hizmet şu anda kullanılamıyor',
	'propLegendPosition': 'Açıklama konumu',
	'propLeft': 'Sol',
	'propRight': 'Sağ',
	'propTop': 'Üst',
	'propBottom': 'Alt',
	'propNone': 'Yok',
	'propLegendDisplay': 'Açıklamayı görüntüle',
	'targetThicknessPlaceHolder': '%{min} - %{max}',
	'targetThicknessErrorMsg': '%{min} ile %{max} arasında bir tamsayı girin.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Sürücüler (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'seçilenler)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Varsayılanlara sıfırla',
	'possibelKeyDriver_AddNewDrivers': 'Daha fazla sürücü ekle',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Daha fazla sürücü eklemek için arayın',
	'possibleKeyDrivers_MaxPossibleReached': 'Başkalarını eklemek ya da seçmek için bazı sürücülerin seçimini kaldırın',
	'possibleKeyDrivers_Recommended': 'Önerilen',
	'visRecommendedTypes': 'Önerilen görselleştirme tipleri',
	'visRecommender_smartsfailure': 'görselleştirme önerileri şu anda kullanılamıyor',
	'visMore': 'Diğer...',
	'visMoreTooltip': 'Diğer görselleştirmeler',
	'visOtherTypes': 'Diğer görselleştirme tipleri',
	'visChange': 'Görselleştirmeyi değiştir',
	'automaticTypeCaption': 'Otomatik',
	'propVisType': 'Görselleştirme tipleri',
	'dlg_loading': 'Yükleniyor...',
	'snippetListChartCaption': 'Kod parçacığı listesi',
	'convoClusterChartCaption': 'Sohbet kümesi',
	'areaChartCaption': 'Alan',
	'barChartCaption': 'Çubuk',
	'columnChartCaption': 'Sütun',
	'stackedbarChartCaption': 'Yığılı çubuk',
	'stackedcolumnChartCaption': 'Yığılı sütun',
	'bubbleChartCaption': 'Kabarcık',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Sürücü analizi',
	'scatterChartCaption': 'Dağılım',
	'lineChartCaption': 'Çizgi',
	'pointChartCaption': 'Nokta',
	'heatChartCaption': 'Isı haritası',
	'bulletChartCaption': 'Madde İşareti',
	'waterfallChartCaption': 'Şelale',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Kutu çizimi',
	'pieChartCaption': 'Pasta',
	'mapChartCaption': 'Harita',
	'radialBarChartCaption': 'Radyal',
	'compositeChartCaption': 'Çizgi ve sütun',
	'wordCloudChartCaption': 'Sözcük bulutu',
	'networkChartCaption': 'Ağ',
	'relationshipNetworkChartCaption': 'İlişki ağı',
	'treemapChartCaption': 'Ağaç eşlemi',
	'packedBubbleChartCaption': 'Paketlenmiş kabarcık',
	'hierarcicalPackedBubbleChartCaption': 'Sıradüzen kabarcığı',
	'spiralChartCaption': 'Spiral',
	'decisionTreeChartCaption': 'Karar ağacı',
	'legacyMapChartCaption': 'Eski harita',
	'sunburstChartCaption': 'Güneş ışığı',
	'visUsageComparison': 'Karşılaştırma',
	'visUsageRelationships': 'İlişkiler',
	'visUsageTrend': 'Eğilim',
	'visUsagePartsToWhole': 'Parçaların bütüne oranı',
	'visUsageGeospatial': 'Jeo-uzamsal',
	'visUsageAdvanced': 'Gelişmiş analitik',
	'visUsageTablesAndSummary': 'Tablolar ve özet',
	'visUsageSocialInsights': 'Sosyal öngörü',
	'visUsageOther': 'Daha Fazla',
	'autoBinActionText': 'Otomatik grupla',
	'filterAutobinActionText': 'Süzgeç bölmeleri',
	'memberCalculationActionText': 'Üye Hesaplaması',
	'toolbarActionCalculation': 'Hesaplama oluştur',
	'toolbarActionEditCalculation': 'Hesaplamayı düzenle',
	'topBottomRankLabel': 'Derece (%{label})',
	'toolbarDeleteFilterActionText': 'Süzgeci kaldır',
	'toolbarActionTopKeyDrivers': 'Sürücüleri göster',
	'toolbarActionCustomGroup': 'Özel grup',
	'canNotCreateCustomGroup': 'Bu özel grubu oluşturamadık.',
	'aria_label_datatable': 'Veri tablosu',
	'summaryCaption': 'Özet',
	'MeasuresCaption': 'Ölçüler',
	'MeasuresGroupCaption': 'Ölçüm grubu (%{count})',
	'ValuesCaption': 'Değerler',
	'turnInsightsOn': 'Öngörüleri aç',
	'turnInsightsOff': 'Öngörüleri kapat',
	'decisionRules': 'Kurallar',
	'decisionTree': 'Ağaç çizgesi',
	'decisionSunburst': 'Ağaç güneş ışığı',
	'switchToDecisionRules': 'Karar kurallarına geç',
	'switchToDecisionTree': 'Karar ağacına geç',
	'data_group_less_then': '%{rangeTo} değerinden küçük',
	'data_group_to': '%{rangeFrom} to < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} ve üstü',
	'nullValueContent': '(değer yok)',
	'sum': 'Toplam',
	'count': 'Say',
	'countdistinct': 'Farklıları say',
	'avg': 'Ortalama',
	'min': 'Minimum',
	'max': 'Maksimum',
	'automatic': 'Özel',
	'variance': 'Fark',
	'stddev': 'Standart Sapma',
	'median': 'Medyan',
	'calculated': 'Hesaplanmış',
	'none': 'Yok',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Bilgi istemi değerleri',
	'inputLabelPrompt': 'Değer',
	'inputPlaceholderPrompt': 'Değer girin',
	'inputInvalidText': '%{dataType} tipi için geçersiz giriş',
	'unSupportedPrompt': 'Desteklenmeyen bilgi istemi',
	'missingDataSource': 'Doğru veri kaynağı bulunamadı.',
	'unSupportedPromptType': 'Bilgi istemi senaryosu şu anda desteklenmiyor.',
	'preAggregateLabel': 'Veri kaynağından bilgi istemi değerlerini uygula',
	'postAggregateLabel': 'Raporda bilgi istemi değerlerini uygula',
	'preAggregateText': 'Aralık, gösterge panosunda görüntülenen değerleri değil, veri kaynağındaki değerleri kullanır.',
	'defaultAggregation_count': 'Say',
	'defaultAggregation_countdistinct': 'Farklıları say',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Ortalama',
	'defaultAggregation_sum': 'Toplam',
	'defaultAggregation_auto': 'Otomatik (%{aggregationType})',
	'keydriver_average': 'Genel ortalama',
	'keydriver_up_down': 'Yüksek veya düşük ortalamalara sahip vurgulanan gruplar, hedef üzerinde daha fazla etkiye sahiptir. Olağan dışı yüksek veya düşük ortalamalara sahip gruplar en güçlü etkiye sahiptir.',
	'keydriver_different': 'Vurgulanan gruplar, genel dağıtımdan büyük ölçüde farklılık gösteren dağıtımlara sahiptir. Bu gruplar, hedef üzerinde daha fazla etkiye sahiptir.',
	'topOperator': 'Üst',
	'bottomOperator': 'Alt',
	'topBottomFact': '%{operator} %{value}%{percent} - %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Üst veya alt sayıyı sil',
	'deleteTopBottomPercent': 'Üst veya alt yüzde işaretini sil',
	'topBottomTitle': 'Yalnızca bu nesne',
	'deleteTopBottom': 'Üst veya alt sayıyı sil',
	'editTopBottom': 'Üst veya alt sayıyı düzenle',
	'editTopBottomCount': 'Üst veya alt sayıyı düzenle',
	'editTopBottomPercent': 'Üst veya alt yüzde işaretini düzenle',
	'ariaDeleteTopBottomCountLabel': 'Üst veya alt sayıyı silmek için DELETE tuşuna basın.',
	'ariaDeleteTopBottomPercentLabel': 'Üst veya alt yüzde işaretini silmek için DELETE tuşuna basın.',
	'ariaEditTopBottomCountLabel': 'Üst veya alt sayıyı düzenlemek için ENTER tuşuna basın.',
	'ariaEditTopBottomPercentLabel': 'Üst veya alt yüzde işaretini düzenlemek için ENTER tuşuna basın.',
	'ariaDeleteDrillStateLabel': 'Üst veya alt sayıyı düzenlemek için ENTER tuşuna basın.',
	'drillUpStateTitle': 'Detayı azalt',
	'drillDownStateTitle': 'Detaya in',
	'ariaEditTopBottomLabel': 'Üst veya alt sayıyı düzenlemek için ENTER tuşuna basın.',
	'ariaDeleteTopBottomLabel': 'Üst veya alt sayıyı silmek için DELETE tuşuna basın.',
	'allKeyDriversLabel': 'Otomatik (tüm sürücüler)',
	'filter_drag_and_drop_single_dock': 'Süzgeç uygulamak için verileri buraya sürükleyip bırakın.',
	'filter_drag_and_drop_all_tabs': 'Bütün sekmelere süzgeç uygulamak için verileri sürükleyip bırakın.',
	'filter_drag_and_drop_current_tab': 'Bu sekmeye süzgeç uygulamak için verileri sürükleyip buraya bırakın.',
	'filter_empty_consume_mode': 'Bir süzgeç uygulanmadı.',
	'filterClearAllItems': 'Tüm süzgeçleri temizle',
	'filterDeleteAllItems': 'Tüm süzgeçleri sil',
	'filterDockChevronLeft': 'Verileri kaydır',
	'filterDockChevronRight': 'Verileri kaydır',
	'filterIconLabel_Single': 'Süzgeçler',
	'filterIconLabel_Global': 'Tüm sekmeler',
	'filterIconLabel_Tab': 'Bu sekme',
	'filterIconTooltip_Single': 'Süzgeçler',
	'filterIconTooltip_Global': 'Tüm sekmeler için süzgeçler',
	'filterIconTooltip_Tab': 'Bu sekme için süzgeçler',
	'filterDropZoneTooltip_Single': 'Süzgeç bırakma bölgesi',
	'filterDropZoneTooltip_Global': 'Tüm sekmeler için süzgeç bırakma bölgesi',
	'filterDropZoneTooltip_Tab': 'Bu sekme için süzgeç bırakma bölgesi',
	'filterOverflowMenu': 'Daha fazla',
	'expand': 'Genişlet',
	'collapse': 'Daralt',
	'filterDockItemNameAriaLabel': 'Süzgeç iletişim kutusunu açmak ve süzgeci tanımlamak için Enter tuşuna basın.',
	'filterItemCanvasMove': 'Tuvale ekle',
	'filterItemDelete': 'Süzgeci sil',
	'filterInvertRange': 'şunun dışında her şey: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': '%{from} tarihinden sonra değil',
	'filter_date_after': '%{from} tarihinden sonra',
	'filter_date_before_except': '%{to} öncesinde değil',
	'filter_date_before': '%{to} tarihinden önce',
	'filter_date_between_except': '%{from} - %{to} arasında değil',
	'filter_date_between': '%{from} - %{to} arasında',
	'filterValueSeparator': ',',
	'filterAll': 'Tümü',
	'filter': 'Süzgeç',
	'filterExcept': 'şunun dışında: %{values}',
	'filterDockToolbarButtonLabel': 'Süzgeç yuvası',
	'navigateTitle': 'Şuraya git:',
	'navigateSelectColumn': 'Sütun seçin',
	'navigateSelectPath': 'Bir dolaşma yolu seçin',
	'current_nav_group': 'Geçerli dolaşma grubu: %{navigation_group_name}',
	'next': 'İleri',
	'previous': 'Önceki',
	'multiselectMsg': '%{count} seçildi',
	'errMsgFilterItemMissingTitle': 'Bu değerler bu veri kümesiyle kullanılabilir olmadığı için %{itemName} süzgeç değeri yüklenemiyor',
	'errMsgFilterItemGenericTitle': 'Süzgeç değerleri yüklenemedi',
	'textFilterItemsNotFound': 'Kullanılabilir öğe yok.',
	'nullValueLabel': '(boş)',
	'filterConditionLabel': 'Süzgeç koşulu',
	'filter_includesAll': 'Tümünü içerir',
	'filter_allMembersOfSet': 'Kümenin tüm üyeleri',
	'modelFilter': 'Süzgeç',
	'filtersTitle': 'Süzgeç özellikleri',
	'search': 'Ara',
	'clearTextFilterValue': 'Temizle',
	'invertFilterSelection': 'Ters Çevir',
	'modellingLoading': 'Yükleniyor...',
	'searchAll': 'Tüm sütunları bul',
	'toolbarActionPossibleKeyDrivers': 'Kapsamı düzenle',
	'toolbarActionPossibleKeyDriversSubTitle': 'Sürücü analizi grafiğinde değerlendirilmesi için soldan öğeleri sürükleyin.',
	'toolbarActionSort': 'Sırala',
	'toolbarActionSortAscending': 'Artan',
	'toolbarActionSortDescending': 'Azalan',
	'toolbarActionSortAuto': 'Otomatik (%{sortOrder})',
	'toolbarActionSortCustom': 'Özel',
	'toolbarActionFormat': 'Verileri biçimlendir',
	'toolbarActionFormatText': 'Verileri biçimlendir (metin)',
	'toolbarActionFormatAbbreviation': 'Kısalt',
	'toolbarActionFormatNone': 'Otomatik',
	'toolbarActionFilter': 'Süzgeç',
	'toolbarActionTopBottom': 'Üst veya alt',
	'toolbarActionRmvShape': 'Şekli kaldır',
	'toolbarActionToggleShapeDrop': 'İnfografik şekli',
	'toolbarActionToggleShapeDropTitle': 'Bir infografik oluşturun',
	'toolbarActionToggleShapeDropText': 'Bir infografik oluşturmak için bu alana bir şekil sürükleyin.',
	'toolbarActionAggregationType': 'Özetle',
	'toolbarDeleteActionText': 'Sütunu kaldır',
	'toolbarTextActionText': 'Stil metni',
	'toolbarActionFilterLocalKeepSelected': 'Tut',
	'toolbarActionFilterLocalExcludeSelected': 'Çıkar',
	'toolbarActionFilterAllKeepSelected': 'Süzgeç',
	'toolbarActionSimpleCalculation': 'Basit hesaplama',
	'toolbarActionDrillBack': 'Geri',
	'toolbarActionDrillUp': 'Detayı azalt',
	'toolbarActionDrillDown': 'Detaya in',
	'toolbarActionJumpTo': 'Detaya geçiş',
	'toolbarActionNavigate': 'Dolaş',
	'toolbarActionCreateFilterGroup': 'Yeni bağlantı oluştur',
	'toolbarActionDisconnectFilterGroup': 'Tüm bağlantıları boz',
	'toolbarActionLinkFilterGroup': 'Var olan bir bağlantıya ekle',
	'toolbarActionLassoSelect': 'Araç seç',
	'toolbarActionRefreshDeveloperWidget': 'Yenile',
	'textFontFamilySubClassHairline': 'İnce Çizgi',
	'textFontFamilySubClassThin': 'İnce',
	'textFontFamilySubClassThinItalic': 'İnce İtalik',
	'textFontFamilySubClassExtraLight': 'Ekstra İnce',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra İnce İtalik',
	'textFontFamilySubClassLight': 'Açık',
	'textFontFamilySubClassLightItalic': 'İnce İtalik',
	'textFontFamilySubClassRegular': 'Düzenli',
	'textFontFamilySubClassRegularItalic': 'Normal İtalik',
	'textFontFamilySubClassItalic': 'İtalik',
	'textFontFamilySubClassMedium': 'Orta',
	'textFontFamilySubClassMediumItalic': 'Orta İtalik',
	'textFontFamilySubClassHeavy': 'Kalın',
	'textFontFamilySubClassHeavyItalic': 'Kalın İtalik',
	'textFontFamilySubClassDemiBold': 'Yarı Kalın',
	'textFontFamilySubClassDemiBoldItalic': 'Yarı Kalın İtalik',
	'textFontFamilySubClassBold': 'Kalın',
	'textFontFamilySubClassBoldItalic': 'Kalın İtalik',
	'textFontFamilySubClassExtraBold': 'Ekstra Kalın',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra Kalın İtalik',
	'textFontFamilySubClassBlack': 'Siyah',
	'textFontFamilySubClassBlackItalic': 'Siyah İtalik',
	'textFontFamilySubClassStencil': 'Kalem',
	'dlg_ascending': 'artan',
	'dlg_descending': 'azalan',
	'dlg_custom': 'özel',
	'dlg_none': 'yok',
	'dlg_hierarchy': 'sıradüzen',
	'dlg_namedSet': 'adlandırılmış küme',
	'dlg_rank': 'derece',
	'visualizationLabel': 'Görselleştirme',
	'chartLabel': '%{chartName} grafiği',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pencere öğesi içinde dolaşmak için F12 tuşuna basın',
	'f10KeyDescription': 'Pencere öğesi odaklanma görünümünü başlatmak için F10 tuşuna basın',
	'playButtonLabel': 'Yürüt',
	'dataPlayerValueListLabel': 'Veri oynatıcı değerleri',
	'localFilterTitle': 'Yalnızca bu nesne',
	'globalFilterTitle': 'Tüm nesneler',
	'deleteFilter': 'Süzgeci sil',
	'editFilter': 'Süzgeci düzenle',
	'ariaEditFilterLabel': 'Süzgeci düzenlemek için ENTER tuşuna basın.',
	'ariaDeleteFilterLabel': 'Süzgeci silmek için DELETE tuşuna basın.',
	'measureFilterBetween': '%{lowerBound} ve %{upperBound} arasında',
	'measureFilterNotBetween': '%{lowerBound} ve %{upperBound} arasında değil',
	'dimFilterIn': 'Şunu içerir: %{in}',
	'dimFilterNotIn': 'Şunu hariç tutar: %{out}',
	'gtFilter': '%{lowerBound} tarihinden sonra',
	'ltFilter': '%{upperBound} tarihinden önce',
	'ariaEditPrompt': 'Bilgi istemi değerini değiştirmek için ENTER tuşuna basın',
	'dataPointFilterTitle': 'Veri noktaları',
	'dataPointFilterIncludeSummary': 'İçerilen %{valueCount} veri noktaları',
	'dataPointFilterExcludeSummary': 'Hariç tutulan %{valueCount} veri noktaları',
	'widgetFiltersLabel': 'Pencere öğesi süzgeçleri',
	'coachMarkTitleSpiralTarget': 'Kapsamı düzenle',
	'coachMarkContentSpiralTarget': 'Burası, hedefiniz için sürücü seçimine erişebileceğiniz ve sürücü seçimini değiştirebileceğiniz yerdir.',
	'srILVTreeLabel': 'Liste',
	'geomapUnrecognizedLocations': 'Tanınmayan konumlar:',
	'geomapAmbiguousLocations': 'Belirsiz bölgeler:',
	'visualizationNotifications': 'Görselleştirme bildirimleri:',
	'dataNotifications': 'Veri bildirimleri:',
	'autobinSuggestion': 'Otomatik gruplamayı aç',
	'LIVE_empty_visualization_hint_title': 'Görselleştirmenizi oluşturun',
	'LIVE_empty_visualization_hint_description': 'Verileri buraya ya da bu alanlara sürükleyin.',
	'LIVE_slots_required_field_description': '%{asterisk} Zorunlu bir alanı belirtir',
	'LIVE_slots_drag_and_drop_description': 'Görselleştirmeyi oluşturmak ve süzgeçten geçirmek için, verileri yukarıdaki alanlara sürükleyip bırakın.',
	'dwErrorLoadingAvailableVisualizations': 'Kullanılabilir görselleştirme tanımları yüklenemiyor',
	'moreDataIndicator': 'Verileriniz %{threshold} öğeye ulaşıldığında kırpıldı. Daha az göstermek için bir süzgeç uygulayın.',
	'nonCtxTopBottomInvalid': 'Çapraz sekmeler için bağlam olmadan üst veya alt kuralın tanımlanması desteklenmez. Bu çapraz sekmedeki görünümden kaldırıldı.  %{columnName} bağlamındaki bir ya da daha çok kategoride kuralı yeniden tanımlayın.',
	'dwErrorLoadingVisualizationNotFound': 'Bir görselleştirme tanımlaması eksik olduğu için nesne yüklenemiyor.',
	'dwErrorLoadingVisualizationListNotFound': 'Görselleştirme yüklenemiyor.',
	'dwErrorRunningQuery': '%{datasetName} veri kümesinden verileri alamıyoruz.',
	'dwErrorGeoData': 'Bir haritadaki coğrafi veriler görüntülenirken sorun oluştu. Lütfen başka bir görselleştirme tipi seçin.',
	'dwPromptSignonCancelWarning': 'Bu görselleştirme verileri kullanılamıyor. Lütfen doğru kimlik bilgilerini girin.',
	'dwErrorMissingDataset': 'İlişkili veri kümesi "%{datasetName}" kullanılabilir olmadığı için görselleştirme yüklenemiyor.',
	'dwErrorRenderingVisualization': 'Bu görselleştirme yüklenemiyor.',
	'dwErrorVisualizationTooSmall': 'Görselleştirme çok küçük olduğundan barındırdığı içerik görüntülenemiyor. Görselleştirmeyi büyütün veya içerdiği verileri sınırlandırın.',
	'errorSourceNotFound': 'İlişkili "%{sourceName}" kaynağı kullanılabilir olmadığı için görselleştirme yüklenemiyor.',
	'errorActionNotSupported': '"%{sourceName}" veri kaynağı için bu işlem desteklenmiyor.',
	'errorMeasureNotSupportedOnMultiEdges': 'Görselleştirme, artık desteklenmeyen birden çok kenarda ölçümler içeriyor. Lütfen ölçümleri yalnızca bir kenara yerleştirin.',
	'errorExceedAllowableValue': 'Tahmini hücre sayısı izin verilebilir 100000 değerini aşıyor. Hücre sayısını azaltmak için lütfen planlanan kümelere süzgeç uygulayın.',
	'propScaleLabel': 'Simge miktarı',
	'propScaleDescription': 'Simgelerin miktarını seçin',
	'propScaleFew': 'Düşük',
	'propScaleDefault': 'Varsayılan',
	'propScaleMany': 'Yüksek',
	'lastRefresh': 'Son yenileme: %{timeInterval} önce',
	'widgetTimer': 'Pencere öğesi zamanlayıcısı',
	'datasetItemsUnavailable': 'Bu görselleştirmede kullanılan bazı veri kümesi öğeleri kullanılamıyor.',
	'datasetItemUnavailable': 'Bu veri kümesi öğesi kullanılamıyor',
	'retry': 'Yeniden Dene',
	'widgetConditionalFormatLabel': 'Koşullu biçim denetimlerini aç/kapat',
	'widgetConditionalFormatTitle': 'Koşullu biçim rengini düzenle',
	'crosstabName': 'Çapraz tablo',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Yok',
	'summaryLabel': '%{value} değerine sahip %{label}',
	'infographicLabel': '%{value} değerine sahip %{label}',
	'warning': 'Uyarı',
	'swapRowsAndColumns': 'Satırların ve sütunların yerini değiştir',
	'hideSummariesLabel': 'Özetleri gizle',
	'showSummariesLabel': 'Özetleri göster',
	'hideRowColumn': 'Gizle',
	'showAllRowColumn': 'Tümünü göster',
	'dataAssetPropertiesLabel': 'Görselleştirme özellikleri',
	'evAdd': 'Sütun ekle',
	'evCollapse': 'Daralt',
	'evColumns': 'Sütunlar',
	'evLocalFilters': 'Yerel süzgeçler',
	'evExpand': 'Genişlet',
	'evFilterTooltip': 'Süzgeç',
	'missingColumn': 'Eksik: %{columnLabel}',
	'missingFiltering': 'Sütunlardaki eksik süzgeçler:',
	'missingDataItem': 'Başvurulan veri öğesi "%{dataItemId}", gereçte bulunamadı.',
	'heatByLabel': 'Isı:',
	'toolbarChangeVisualization': 'Görselleştirmeyi değiştir',
	'modellingRelatedTablesNoneFound': 'İlgili tablo bulunamadı',
	'processing': 'İşleniyor...',
	'errorCellWarning': 'Bazı özet değerleri hesaplanamadı.',
	'aggregateTypeToggler': 'Toplama tipini göster',
	'maxColumnsExceeded': 'Maksimum sütun sayısı aşıldı. %{columns} düştü.',
	'unboundColumns': 'Şu sütunlar kullanılamıyor: %{columns}.',
	'unboundColumn': 'Şu sütun kullanılamıyor: %{columns}.',
	'recommendRequestFailed': 'Öneri isteği başarısız oldu. Lütfen yöneticinizle iletişime geçin.',
	'visualizationDoesNotSupportOLAP': 'OLAP veri kaynağını temel alan bu görselleştirmeyi oluşturamıyoruz. Lütfen başka bir desteklenen veri kaynağı kullanın.',
	'showDataBehindVizLabel': 'Verileri göster',
	'showDataBehindVizNotSupportedLabel': 'Bu görselleştirme tipi için verileri gösterme desteklenmiyor',
	'exploreData': 'Keşfet...',
	'newExplore': 'Yeni Keşif',
	'thumbnails_error_fetching': 'Küçük resimler getirilirken hata oluştu',
	'loadedThumbnailImage': '%{visType} görselleştirme küçük resim resmi yüklendi',
	'autobinAxisLabel': 'gruplar',
	'recommended_visualizations': 'Önerilen görselleştirmeler',
	'all_visualizations': 'Tüm görselleştirmeler',
	'edit': 'Düzenle',
	'selectTargetDialogTitle': 'Bir detaya geçiş hedefi seçin',
	'noTargetInCM': 'Detaya geçişin hedefi bulunamıyor',
	'errorDrillDefinition': 'Detaya geçiş tanımlamasını eklerken ya da düzenlerken bir sorun oluştu.',
	'errorDrillToTarget': '"%{targetName}" ayrıntısına inme sırasında bir hata oluştu',
	'drillThroughMappingViewLabel': 'Gösterge panonuzdaki sütunları, hedef raporun bilgi istemlerine atayın',
	'drillthroughScopeRadioLabel': 'Tanımlamayı şuna uygula:',
	'drillthroughScopeRadioOptionVisualization': 'Yalnızca bu görselleştirme',
	'drillthroughScopeRadioOptionConnection': 'Aynı veri kaynağını kullanan aynı bağlantıdaki görselleştirmeler',
	'drillthroughScopeRadioOptionDashboard': 'Aynı veri kaynağını kullanan %{perspective} üzerinde herhangi bir görselleştirme',
	'drillThroughParametersColumnTitle': '"%{targetName}" bilgi istemleri:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" veri sütunları:',
	'drillThroughDefinitionNoParameter': 'Detaya geçiş hedefinin bilgi istemi yok.',
	'drillThroughDefinitionErrorQueryingReport': 'Hedef raporla ilgili sorunu düzeltin ve sonra detaya geçiş tanımlaması oluşturmayı yeniden deneyin.',
	'drillThroughDefinitionErrorDlgTitle': 'Bir sorun oluştu',
	'dlg_back': 'Geri git',
	'dlg_close': 'Kapat',
	'dlg_ok': 'Tamam',
	'dlg_cancel': 'İptal',
	'dlg_apply': 'Uygula',
	'dlg_create': 'Oluştur',
	'dlg_done': 'Bitti',
	'drillthrough_unsaveMsg': '"%{name}" kaydedilmeden devam edilsin mi?',
	'drillthrough_jumpTo': 'Detaya geçiş tanımlaması: %{name}',
	'drillthrough_jumpToLabel': 'Detaya geçiş',
	'drillthrough_manage': 'Yönet...',
	'drillthrough_addNewTarget': 'Yeni bir detaya geçiş tanımlaması ekleyin',
	'drillthrough_manageJumpPaths': 'Detaya geçiş tanımlamalarını yönet',
	'drillthrough_manageJumpPaths_edit': 'Düzenle - "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Sil - "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Başka bir detaya geçiş tanımlaması ekleyin',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Silmeyi onayla',
	'drillthrough_manageConfirmeDeleteDrillTarget': '"%{name}" detaya geçişini silmek istediğinizden emin misiniz?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Yinelenen detaya geçiş adı',
	'drillthrough_definitionMessage': 'Detaya geçiş "%{name}" zaten var. Farklı bir ad sağlayın.',
	'drillthrough_jumpToTarget_notFound': 'Detaya geçiş "%{name}" için hedef bulunamadı',
	'drillThroughDefinitionNoParameterSubTitle': 'Hedef rapora bir bağlam iletilmeyecek.',
	'drillthrough_titleLabel': 'Ad',
	'drillthrough_create_dialogTitle': 'Detaya geçiş tanımlaması oluştur',
	'drillthrough_edit_dialogTitle': 'Detaya geçiş tanımlamasını düzenle',
	'drillthrough_subTitle': 'Kaynağınızdaki görselleştirmenin bağlamı, hedef %{perspective} öğesini süzgeçten geçirmek için kullanılır.',
	'drillthrough_selectColumn': 'Sütun seçin',
	'noPrompt': 'Bilgi istemi yok',
	'promptDialog': '%{promptType} bilgi istemi iletişim kutusu',
	'formatAutoDescription': 'Veri kaynağınızdan veya görselleştirmenizden devralınan biçimi otomatik olarak belirtir.',
	'formatDefaultDescription': 'Varsayılan değer, sistemden devralınan biçimi belirtir',
	'createCustomGroupAction': 'Veri grubu oluştur',
	'removeCustomGroupAction': 'Veri grubunu kaldır',
	'editCustomGroupAction': 'Veri grubunu düzenle',
	'renameCustomGroupAction': 'Veri grubunu yeniden adlandır',
	'createCustomGroupErrorToast': 'Veri grubunuz oluşturulamadı.',
	'removeCustomGroupErrorToast': 'Veri grubunuz kaldırılamadı.',
	'editCustomGroupErrorToast': 'Veri grubunuz düzenlenemedi.',
	'renameCustomGroupErrorToast': 'Veri grubunuz yeniden adlandırılamadı.',
	'customGroupLabel': 'Veri grubu oluştur',
	'ungroupCustomGroupLabel': 'Grubu çöz',
	'renameCustomGroupLabel': 'Yeniden Adlandır',
	'createCustomGroupLabel': 'Oluştur',
	'customGroupingLabel': '%{columnLabel} (Grup)',
	'createCustomSort': 'Özel sıralama oluştur',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Kullanılabilir öğeleri seçin, ardından özel bir sıralama oluşturmak için yeniden düzenleyin.',
	'availableItems': 'Kullanılabilir öğeler',
	'selectAll': 'Tümünü seç',
	'customSortOrder': 'Özel sıralama düzeni',
	'selectAvailableItemsDesc': 'Kullanılabilir öğeleri seçin, ardından burada yeniden sıralayın.',
	'moveToTop': 'En üste taşı',
	'clear': 'Temizle',
	'sortRemainingItemsBy': 'Kalan öğeleri sıralama ölçütü',
	'removeAll': 'Tümünü kaldır',
	'resetTooltip': 'Tüm öğeler %{customSortOrder} listesinden kaldırılacak. Ve %{sortRemainingItemsBy} açılan listesi varsayılan değere geri çevrilecek.',
	'manyItemsWarning': 'Birden çok öğenin seçilmesi gösterge panonuzun performansını etkileyebilir.',
	'manyItemsSelected': '%{maxItems} öğeden fazla öğe seçildi, bu durum gösterge panonuzun performansını etkileyebilir.',
	'somethingWentWrong': 'Üzgünüz, Bazı şeyler doğru olmadı. ',
	'tryAgain': 'Yeniden deneyin',
	'customSortLabel': 'Özel sıralama',
	'applyError': '%{action} uygulanamıyor.',
	'searchReturnedNoResults': 'Aramanız herhangi bir sonuç döndürmedi.',
	'extVisSystem': 'Sistem',
	'extVisCustom': 'Özel',
	'customVisTestVisualization': 'Görselleştirmeyi test edin',
	'extVisCustomVisPreview': 'önizleme',
	'extVisCustomPreviewWidgets': 'Geliştirici pencere öğeleri',
	'extVisCustomVVisualization': 'Görselleştirme',
	'extVisCustomVisuals': 'Özel görseller',
	'noPermissionToManage': 'Özel görselleştirmeleri yönetme izniniz yok.',
	'extVisCustomUpdate': 'Güncelle',
	'extVisCustomDelete': 'Sil',
	'extVisNoCustomVisuals': 'Özel görsel yok',
	'extVisNoCustomVisualsMsg': 'Şu anda kuruluşunuzda bir özel görsel yok',
	'extVisAddCustomVisual': 'Özel görsel ekle',
	'extVisNoCustomVisualsAdminMsg': 'Şu anda bir özel görsel yok. Başlamak için bir tane ekleyin',
	'extVisNoSDKConnection': 'Yerel dosyanıza bağlantı oluşturulmadı',
	'extVisNoSDKPreviewMsg': 'Görselleştirmelerinizi önizlemek için lütfen bir bağlantı kurun.',
	'extVisMore': 'Daha fazla',
	'extVisDeleteDialogTitle': 'Özel görseli sil',
	'extVisDeleteDialogBody': 'Bu özel görselleştirmeyi silmek istediğinizden emin misiniz? Bu, diğer gösterge panoları ve raporlar tarafından kullanılıyor olabilir.',
	'extVisDeleteConfirmation': 'Özel görseliniz silindi.',
	'extVisDeleteError': 'Özel görseliniz silinemedi. %{msg}',
	'extVisCloseToast': 'Şimdi kapat',
	'extVisAdd': 'Özel görseliniz başarıyla eklendi.',
	'extVisAddError': 'Özel görseliniz eklenemedi. %{msg}',
	'extVisUpdate': 'Özel görseliniz başarıyla güncellendi.',
	'extVisUpdateError': 'Özel görseliniz güncellenemedi. %{msg}',
	'extVisAddProgress': '%{name} içe aktarılıyor',
	'extVisUpdateProgress': '%{name} güncelleniyor',
	'extPermissionTitle': 'Kısıtlı erişim veya özel görsel silindi',
	'extPermissionBody': 'Bu özel görsel silinmiş olduğundan veya kısıtlı erişime sahip olduğundan görüntülenemiyor.',
	'customVizSaveWarning': 'Özel görselleriniz kaydedilemiyor. İçe aktarılmadılar.',
	'schematicTestCaption': 'Şemayı test et',
	'schematicServiceRequestError': 'Şema hizmeti hatası',
	'extVisPreviewMessage': 'Bu bir önizlemedir. Görselleştirme henüz ürüne eklenmedi.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Tanımlı değil',
	'kpiDefaultTargetLabel': 'Hedef',
	'kpiNonNumericTarget': 'Hedef değer bir sayı olmalıdır.',
	'kpiManualTargetSlotFilled': 'Alana uygulanan değer',
	'kpiAutoValueSize': 'Otomatik',
	'kpiUnableDrawSparklineLabel': 'Mini grafik çizilemiyor',
	'kpiUnableDrawSparklineInfo': 'Mini grafik için en az iki zaman noktası gerekir. Mini grafiği görmek için süzgeçleri ayarlayın veya verileri değiştirin.',
	'conditionalFormattingTextColor': 'Metin rengi',
	'suppression': 'Gizleme',
	'suppressNone': 'Yok',
	'suppressRowsAndColumns': 'Satırlar ve Sütunlar',
	'suppressRows': 'Satırlar',
	'suppressColumns': 'Sütunlar',
	'enableSuppression': 'Gizlemeyi etkinleştir',
	'disableSuppression': 'Gizlemeyi devre dışı bırak',
	'loadVisDefinitionError': '%{id} görselleştirmesi için tanımlama yüklenemiyor',
	'emptyVisualization': 'Boş görselleştirme',
	'expandCollapse': 'Genişlet ve daralt',
	'expandBtnLabel': 'Genişlet',
	'collapseBtnLabel': 'Daralt',
	'prop_sizeInputNonNumericValue': 'Değer bir sayı olmalıdır.',
	'prop_sizeValueShouldBeHigher': 'Değer, %{value} değerinden büyük olmalıdır.',
	'fontPropLabel': 'Yazı tipi ailesi',
	'fontSizePropLabel': 'Yazı tipi boyutu',
	'sectionItemAxisTitle': 'Öğe ekseni başlığı',
	'sectionItemAxisLabel': 'Öğe ekseni etiketi',
	'sectionValueAxisTitle': 'Değer ekseni başlığı',
	'sectionValueAxisLabel': 'Değer ekseni etiketi',
	'styletext-widget.legend': 'Açıklama',
	'styletext-itemAxis.ticks.labels': 'Eksen etiketleri',
	'styletext-valueAxis.title': 'Eksen başlıkları',
	'styletext-itemAxis.title': 'Eksen başlıkları',
	'styletext-labels': 'Veri etiketleri',
	'styletext-valueAxis.line.title': 'Çizgi başlıkları',
	'styletext-cellValue': 'Değerler',
	'styletext-values': 'Değerler',
	'styletext-rowHeading': 'Satır başlıkları',
	'styletext-columnHeading': 'Sütun başlıkları',
	'fontFamily': 'aile',
	'fontSize': 'boyut',
	'visExportFileName': 'Görselleştirme',
	'ds-missingDataSet': 'Veri kümesi bulunamadı. Lütfen veri kümesinin başarıyla oluşturulduğundan emin olun.',
	'ds-missingDashboardId': 'Lütfen veri kümesini oluşturmadan önce gösterge panosunu kaydedin.',
	'ds-unsupportedDataSourceType': '%{type} veri kaynağı türü desteklenmiyor.',
	'dataCache': 'Veri önbelleği',
	'dataCache_on': 'Açık',
	'dataCache_off': 'Önbellek yok',
	'dataCache_auto': 'Otomatik',
	'queryOptimization': 'Sorgu optimizasyonu'
});
